"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDishGroupItem = addDishGroupItem;
exports.batchAddGroups = batchAddGroups;
exports.batchClearGroupItems = batchClearGroupItems;
exports.batchClearGroups = batchClearGroups;
exports.batchDeleteDishGroupItem = batchDeleteDishGroupItem;
exports.deleteById = deleteById;
exports.deleteDishGroupItem = deleteDishGroupItem;
exports.downloadGoodsImportTemplate = downloadGoodsImportTemplate;
exports.downloadGroupInfo = downloadGroupInfo;
exports.getById = getById;
exports.getDishGroupItems = getDishGroupItems;
exports.importGoodsExcel = importGoodsExcel;
exports.migrateDishGroupItems = migrateDishGroupItems;
exports.queryGoodsGroups = queryGoodsGroups;
exports.queryGoodsWithGroups = queryGoodsWithGroups;
exports.queryList = queryList;
exports.save = save;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 下载分组商品导入模板
function downloadGoodsImportTemplate(operation) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/downloadGoodsImportTemplate',
    method: 'get',
    params: {
      operation: operation
    },
    responseType: 'blob'
  });
}

// 导入分组商品Excel
function importGoodsExcel(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/importGoodsExcel',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 明细列表
function getDishGroupItems(query) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/getDishGroupItems',
    method: 'get',
    params: query
  });
}

// 明细保存
function addDishGroupItem(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/addDishGroupItem',
    method: 'post',
    data: data
  });
}

// 明细删除
function deleteDishGroupItem(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/deleteDishGroupItem?id=' + id,
    method: 'get'
  });
}

// 批量删除明细
function batchDeleteDishGroupItem(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/batchDeleteDishGroupItem',
    method: 'post',
    data: data
  });
}

// 列表
function queryList(query) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/page',
    method: 'get',
    params: query
  });
}

// 保存
function save(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/saveXyMenuDishGroup',
    method: 'post',
    data: data
  });
}

// 删除
function deleteById(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/deleteXyMenuDishGroup?id=' + id,
    method: 'get'
  });
}

// 通过id等级信息
function getById(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/' + id,
    method: 'get'
  });
}

// 下载分组信息Excel
function downloadGroupInfo() {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/downloadGroupInfo',
    method: 'get',
    responseType: 'blob'
  });
}

// 批量清空分组商品
function batchClearGroupItems(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/batchClearGroupItems',
    method: 'post',
    data: data
  });
}

// 迁移分组商品
function migrateDishGroupItems(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/migrateDishGroupItems',
    method: 'post',
    data: data
  });
}

// 查询商品列表及其所属分组
function queryGoodsWithGroups(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/queryGoodsWithGroups',
    method: 'post',
    data: data
  });
}

// 批量添加分组商品（将多个商品添加到多个分组）
function batchAddGroups(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/batchAddGroups',
    method: 'post',
    data: data
  });
}

// 查询商品所属分组
function queryGoodsGroups(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/queryGoodsGroups',
    method: 'post',
    data: data
  });
}

// 批量清除分组商品（从多个分组中清除多个商品）
function batchClearGroups(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuDishGroup/batchClearGroups',
    method: 'post',
    data: data
  });
}